/* Sramika's numbers (23 Oct 2026, mock CallBook_1; one number since 27 Oct, mock CallExo_1).
   CALL_NUMBER: "Call to book" - customers phone us and we book the trip for them. Since
   27 Oct 2026 it is the company SIM, the same as WhatsApp: the SIM forwards every call to
   Exotel 040 4189 7977, which rings the team one after another (inboundCallsController).
   Every Help button reads the same number from COMPANY_SETTINGS.supportPhoneNumber.
   WHATSAPP_NUMBER: the WhatsApp Business number - chats, the bot, deletion requests. */
export const CALL_NUMBER = "8341265847";
export const WHATSAPP_NUMBER = "8341265847";
export const prettyNumber = (d) => `${String(d).slice(0, 5)} ${String(d).slice(5)}`;
